


















































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import MonitorTandaVitalChart from "@/components/chart/MonitorTandaVitalChart.vue";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import Readback from "@/services/Readback";
import { storeDokter } from "@/store/modules/dokter";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({
  components: {
    ModalBatalSoap,
    MonitorTandaVitalChart,
    VCDateTimePicker
  }
})
export default class ReadBackInput extends Vue {
  @Ref() examinedAtPicker: HTMLElement;
  @Ref() readonly sub;
  @Prop({ default: false }) readonly readonly?: boolean;
  @Prop() value: {
    id: number;
    register_id: number;
    pasien_rm: string;
    unit_id: string;
    consultant_user_id: number;
    consulting_user_id: number;
    message: string;
    instruction: string;
    consulting_at: string;
    verified_at: string;
    consultant_verified_at: string;
    dpjp_verified_at: string;
    dpjp_user_id: string;
  };
  @Prop({ default: false }) isActive?: boolean;

  isFormValid = true;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  id = null;
  consultant_user_id: number = null;
  consulting_user_id: number = null;
  message: string = null;
  instruction: string = null;
  consulting_at: string | Date = null;
  consultant_verified_at: string | Date = null;
  dpjp_verified_at: string | Date = null;
  examinedAt: Date = null;
  verifiedAt: string | Date = null;

  removing = false;
  saving = false;

  showBatal = false;

  get listDokter() {
    return storeDokter.list.filter(it => it.id != userModule.user.id);
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.examinedAt > dtime) {
      this.$nextTick(() => {
        this.examinedAt = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  @Watch("value", {
    deep: true
  })
  changedValue(newVal, oldVal) {
    console.log("changedValue ReadBackInput", newVal, oldVal);
    if (!newVal) {
      this.clearInput();
    } else if (newVal != oldVal) {
      // mode edit / copy soap
      this.id = newVal.id;
      this.message = newVal.message;
      this.instruction = newVal.instruction;
      this.consultant_user_id = parseInt(newVal.consultant_user_id);
      this.consulting_user_id = parseInt(newVal.consulting_user_id);
      this.consulting_at = newVal.consulting_at;
      this.examinedAt = newVal.consulting_at;
      this.verifiedAt = newVal.dpjp_verified_at;
    }
  }

  get canEdit() {
    return this.isNakes && this.id;
  }

  get canMakeSoap() {
    return this.isNakes;
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.activeUser.profesi);
  }

  get isNonMedis() {
    return this.activeUser.profesi !== "Dokter" && this.isNakes;
  }

  get isNakes() {
    return this.activeUser.is_nakes;
  }

  get registerId(): number {
    return parseInt(this.$route.params.register);
  }

  get pasienRm(): string {
    return this.$route.params.rm;
  }

  get activeUser() {
    return userModule.user;
  }

  get formatedExaminedAt() {
    return this.examinedAt
      ? moment(this.examinedAt.setSeconds(new Date().getSeconds())).format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get input() {
    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.id ? this.value.unit_id : this.activeUser.unit_id,
      message: this.message,
      instruction: this.instruction,
      consultant_user_id: this.consultant_user_id,
      consulting_user_id: this.consulting_user_id ?? this.activeUser.id,
      consulting_at: this.formatedExaminedAt
    };
  }

  get isVerified() {
    return this.verifiedAt ? true : false;
  }

  async mounted() {
    this.clearInput();
    this.$nextTick(() => {
      this.sub.focus();
    });
  }

  async save() {
    if (!this.saving) {
      this.saving = true;

      try {
        const isEdit = !!this.id;
        const resp = this.id
          ? await Readback.update(this.id, this.input)
          : await Readback.create(this.input);
        if (!this.id) {
          this.id = resp["id"];
        }
        this.clearInput();
        appModule.sendSuccessNotice(
          isEdit ? "Readback berhasil diubah" : "Readback berhasil disimpan"
        );

        this.getByRegister();
      } finally {
        this.saving = false;
      }
    }
  }

  get isDisabledInput() {
    return false;
  }

  get disabledInputMsg() {
    return null;
  }

  async remove(alasan = null) {
    if (!this.removing) {
      this.removing = true;

      try {
        await Readback.destroy(this.id, alasan?.alasan);

        await this.getByRegister();

        this.clearInput();
      } catch (err) {
        //
      } finally {
        this.removing = false;
      }
    }
  }

  async getByRegister() {
    await CpptRanapStore.getReadbackByRegister(this.registerId);
  }

  removeHandler() {
    const q = confirm("Menghapus Catatan Readback ini?");

    if (q) {
      // this.showBatal = true;
      this.remove();
    }
  }

  clearInput() {
    this.id = null;
    this.message = null;
    this.instruction = null;
    this.consultant_user_id = null;
    this.consulting_user_id = null;
    this.consulting_at = null;
    this.examinedAt = null;
    this.verifiedAt = null;

    this.$emit("input", null);
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }
}
